import { Directive, OnDestroy, Renderer2, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive()
export abstract class CdkPageLockComponent implements OnDestroy {
  readonly scrollPosition = signal(0);
  readonly isLock = signal(false);

  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private readonly noScrollClass = 'no-scroll';

  protected constructor(
    private platformId: object,
    private document: Document,
    private renderer: Renderer2
  ) {}

  ngOnDestroy(): void {
    // 一定要確保移除 no-scroll class.
    this.releasePage();
    this.onDestroy();
  }

  lockPage(): void {
    if (this.isBrowser) {
      // code 順序不要動, 先記錄當下捲軸位置, 然後 fixed body, 然後 top: -捲軸高度.
      this.scrollPosition.set(this.document.documentElement.scrollTop);
      this.renderer.addClass(this.document.body, this.noScrollClass);
      this.document.body.style.top = `-${this.scrollPosition()}px`;
      this.isLock.set(true);
    }
  }

  releasePage(): void {
    if (this.isBrowser && this.isLock()) {
      // 避免刷新頁面 ngOnDestroy SSR 拿不到 window 物件.
      this.renderer.removeClass(this.document.body, this.noScrollClass);
      this.document.body.style.top = '0';
      window.scrollTo(0, this.scrollPosition());
      this.isLock.set(false);
    }
  }

  onDestroy(): void {
    // for override
  }
}
